import { lazy, Suspense } from "react";

import { LoadingIndicatorFullPage } from "../../../cc-ui/components";

const Deals = lazy(() => import("./Deals").then((module) => ({ default: module.Deals })));

export const DealsAsync = () => {
  return (
    <Suspense fallback={<LoadingIndicatorFullPage open />}>
      <Deals />
    </Suspense>
  );
};
